// Generado por scripts/icon-version.mjs a partir del contenido de los iconos. No editar a mano.
export const ICON_VERSION = '4c003625'
